import React, { useState, useEffect } from 'react'
import { Box, Typography, CircularProgress } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import scriptLoader from 'react-async-script-loader'
import { isNil } from 'lodash'

import { MAPS_SCRIPT_URL } from '../components/location-search/LocationSearchBox'
import LocationSupported from '../components/property-management/LocationSupported'
import LocationUnsupported from '../components/property-management/LocationUnsupported'
import { search, getAddressByPlaceId } from '../redux/modules/locationSearch'
import { formatAddress } from '../util/formatUtils'

const CenterWrapper = ({ children }) => (
  <Box
    display="flex"
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    height="calc(100vh - 64px)"
    width="100%"
  >
    {children}
  </Box>
)

const PagePropertySearchLanding = ({ isScriptLoaded }) => {
  const locations = useSelector(state => state.locationSearch.locations)
  const params = useParams()
  const dispatchRedux = useDispatch()
  const [isSupported, setIsSupported] = useState(null)

  useEffect(() => {
    const getAddress = async placeId => {
      const result = await getAddressByPlaceId(placeId)
      const formattedAddr = formatAddress(result.address)
      dispatchRedux(search(formattedAddr, false, null, null, null, true))
    }
    if (params.place_id && isScriptLoaded) {
      getAddress(params.place_id)
    }
  }, [dispatchRedux, params, isScriptLoaded])

  useEffect(() => {
    if (!isNil(locations)) {
      setIsSupported(locations.length > 0)
    }
  }, [locations])

  if (isSupported === null) {
    return (
      <CenterWrapper>
        <CircularProgress />
        <Box mt={4}>
          <Typography variant="h5">Checking Location...</Typography>
        </Box>
      </CenterWrapper>
    )
  }

  if (isSupported) {
    return (
      <CenterWrapper>
        <LocationSupported placeId={params.place_id} />
      </CenterWrapper>
    )
  }

  return (
    <CenterWrapper>
      <LocationUnsupported />
    </CenterWrapper>
  )
}

export default scriptLoader(MAPS_SCRIPT_URL)(PagePropertySearchLanding)
